import { render, staticRenderFns } from "./ClaimCard.vue?vue&type=template&id=63dd46f6&scoped=true"
import script from "./ClaimCard.vue?vue&type=script&lang=js"
export * from "./ClaimCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd46f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63dd46f6')) {
      api.createRecord('63dd46f6', component.options)
    } else {
      api.reload('63dd46f6', component.options)
    }
    module.hot.accept("./ClaimCard.vue?vue&type=template&id=63dd46f6&scoped=true", function () {
      api.rerender('63dd46f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/ClaimCard.vue"
export default component.exports